class BannerCarousel {
  constructor(root) {
    this.root = root;
    this.sectionId = root?.dataset?.sectionId;
    this.swiperEl = root?.querySelector('[data-banner-carousel-swiper]');
    this.swiper = null;
    this.init();
  }

  getConfig() {
    const totalSlides = this.root.querySelectorAll('.banner-carousel__slide').length;
    const mobileColumns = parseFloat(this.root.dataset.mobileColumns || '1');
    const desktopColumns = parseFloat(this.root.dataset.desktopColumns || '3');
    const spaceBetween = parseInt(this.root.dataset.spaceBetween || '0', 10);
    const autoRotate = this.root.dataset.autoRotate || 'disabled';
    const enableLoopSetting = this.root.dataset.enableLoop === 'true';
    const showPagination = this.root.dataset.showPagination === 'true';
    const showCounter = this.root.dataset.showCounter === 'true';
    const showNavigation = this.root.dataset.showNavigation === 'true';

    // Enable loop if manually enabled OR if auto-rotate is active
    const enableLoop = (enableLoopSetting || autoRotate !== 'disabled') && totalSlides > Math.max(mobileColumns, desktopColumns);

    const config = {
      slidesPerView: mobileColumns,
      spaceBetween,
      loop: enableLoop,
      speed: 600,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      breakpoints: {
        768: {
          slidesPerView: desktopColumns,
          spaceBetween,
        },
      },
      on: {
        slideChange: () => {
          if (showCounter) {
            this.updateCounter();
          }
        },
      },
    };

    if (autoRotate !== 'disabled') {
      config.autoplay = {
        delay: parseInt(autoRotate, 10) * 1000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      };
    }

    if (showPagination) {
      config.pagination = {
        el: this.root.querySelector('[data-banner-carousel-pagination]'),
        clickable: true,
        dynamicBullets: true,
      };
    }

    if (showNavigation) {
      config.navigation = {
        nextEl: this.root.querySelector('[data-banner-carousel-next]'),
        prevEl: this.root.querySelector('[data-banner-carousel-prev]'),
      };
    }

    return config;
  }

  init() {
    if (!this.root || !this.swiperEl) return;

    if (this.swiperEl.swiper) {
      this.swiperEl.swiper.destroy(true, true);
    }

    this.waitForSwiper(() => {
      this.initSwiper();
    });
  }

  waitForSwiper(callback) {
    if (typeof Swiper !== 'undefined') {
      callback();
      return;
    }

    const checkSwiper = setInterval(() => {
      if (typeof Swiper !== 'undefined') {
        clearInterval(checkSwiper);
        callback();
      }
    }, 50);

    setTimeout(() => {
      clearInterval(checkSwiper);
    }, 5000);
  }

  initSwiper() {
    try {
      this.swiper = new Swiper(this.swiperEl, this.getConfig());
      // Initialize counter if enabled
      if (this.root.dataset.showCounter === 'true') {
        this.updateCounter();
      }
    } catch (error) {
      // no-op (keep silent in production)
    }
  }

  updateCounter() {
    const counterEl = this.root.querySelector('[data-banner-carousel-counter]');
    if (!counterEl || !this.swiper) return;

    const currentEl = counterEl.querySelector('.banner-carousel__counter-current');
    if (!currentEl) return;

    // Get real index (handles loop mode)
    const realIndex = this.swiper.realIndex !== undefined ? this.swiper.realIndex : this.swiper.activeIndex;
    currentEl.textContent = realIndex + 1;
  }

  destroy() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}

function initBannerCarousels(scope = document) {
  scope.querySelectorAll('[data-banner-carousel]').forEach((root) => {
    if (root.__bannerCarousel) root.__bannerCarousel.destroy();
    root.__bannerCarousel = new BannerCarousel(root);
  });
}

document.addEventListener('DOMContentLoaded', () => initBannerCarousels());

if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initBannerCarousels(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target.querySelector('[data-banner-carousel]');
    if (root && root.__bannerCarousel) {
      root.__bannerCarousel.destroy();
      root.__bannerCarousel = null;
    }
  });
}


